import { useContext } from 'react';
import { ReducerContext } from 'src/context/reducer-context';

export default function useReducer() {
  const { dispatch, models, registerModel, registerReducer } = useContext(ReducerContext);
  return { dispatch, models, registerModel, registerReducer };
}
